import { downloadApk } from '../../../utils/downloadApk';

export function AppComingSoonSection() {
  return (
    <section className="relative py-16 md:py-24 px-4 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img alt="Baccarat Table" className="w-full h-full object-cover opacity-25 md:opacity-35" src="/assets/welcome/4.png" />
        <div className="absolute inset-0 bg-gradient-to-t from-darker via-darker/75 to-darker/50" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center px-2">
        <span className="inline-block mb-4 md:mb-6 px-4 py-1.5 rounded-full bg-accent/20 border border-accent/40 text-accent text-xs font-bold uppercase tracking-widest">
          Android App Available
        </span>
        <h2 className="font-serif text-3xl sm:text-4xl md:text-6xl font-black mb-4 md:mb-6 leading-tight">
          Golden 777 in
          <br />
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-accent via-white to-primary">Your Pocket</span>
        </h2>
        <p className="text-slate-300 text-sm sm:text-base md:text-xl mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed">
          Download the Golden 777 app now and play your favorite slots &amp; live tables anywhere, anytime. Fast payouts, exclusive bonuses.
        </p>

        <button
          type="button"
          onClick={downloadApk}
          className="group inline-flex items-center gap-3 px-10 py-4 bg-accent text-darker font-black text-base md:text-lg rounded-full hover:bg-white transition-all transform hover:scale-105 active:scale-95 shadow-2xl shadow-accent/30 mb-8"
        >
          <span className="material-icons text-2xl">android</span>
          <span className="uppercase tracking-tighter">Download APK</span>
          <span className="material-icons transition-transform group-hover:translate-y-0.5">download</span>
        </button>

        <div className="mt-2 flex flex-col sm:flex-row items-center justify-center gap-4">
          <div className="flex items-center gap-2 px-5 py-3 bg-white/5 border border-white/10 rounded-2xl">
            <span className="material-icons text-accent text-2xl">android</span>
            <div className="text-left">
              <p className="text-xs text-slate-400">Download for</p>
              <p className="text-sm font-bold">Android APK</p>
            </div>
          </div>
          <div className="flex items-center gap-2 px-5 py-3 bg-white/5 border border-white/10 rounded-2xl opacity-50">
            <span className="material-icons text-2xl">phone_iphone</span>
            <div className="text-left">
              <p className="text-xs text-slate-400">Coming soon</p>
              <p className="text-sm font-bold">iOS App Store</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
